import React, { useState, useEffect, Fragment } from "react";
import { ContextMenu, MenuItem, ContextMenuTrigger } from "react-contextmenu";
import { useHistory, useLocation } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";

const AssessmentFirstSound = ({
  assessment,
  forceUpdate,
  setRestartKey,
  restartKey,
  setDone,
  setPlay,
  updateAssessmentResult,
  assessmentResults,
  deleteResult,
  clearResult,
  user,
  isAuthenticated,
  setValidationChecklist,
}) => {
  const hist = useHistory();
  const location = useLocation();

  const format = (data) => {
    const Body = data.Body.split(",");
    const Solution = data.Solution.split(",");
    const SolutionDetails = data.SolutionDetails.split(",");

    let arr = [];
    for (let i = 0; i < Body.length; i++) {
      arr.push({
        word: Body[i],
        solution: Solution[i],
        solutionDetails: SolutionDetails[i].replace(/\s+/g, " ").split(" "),
      });
    }
    return arr;
  };

  const zeros = (arr) => {
    let r = [];
    for (let i = 0; i < arr.length; i++) {
      r.push(0);
    }
    return r;
  };

  const validateEndMark = (results) => {
    if (results.includes(4) || results.includes("4")) {
      setValidationChecklist((prev) => {
        return prev?.map((item) => {
          if (item.desc === "Placed end mark") {
            return { ...item, checked: true };
          }
          return item;
        });
      });
    } else {
      setValidationChecklist((prev) => {
        return prev?.map((item) => {
          if (item.desc === "Placed end mark") {
            return { ...item, checked: false };
          }
          return item;
        });
      });
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    let data = {
      ...assessmentResults,
      // TotalScore: Math.round(
      //   (scores.reduce((a, b) => {
      //     if (a === "") {
      //       return b;
      //     } else if (b === "") {
      //       return a;
      //     } else {
      //       return a + b;
      //     }
      //   }, 0) /
      //     (assessment.Body.split(",").length * 2)) *
      //     100
      // ),
      TotalScore: Math.round(
        scores.reduce((a, b) => {
          if (a === "") {
            return b;
          } else if (b === "") {
            return a;
          } else {
            return a + b;
          }
        }, 0),
      ),
      Scores: scores.join(","),
      CategoryID: assessment.CategoryID,
      Comment: comment,
      Year: assessmentResults.year,
      SoundsIndex: solutionLabel,
      SoundsLength: solutionDetailsLabel,
      CreatedDate: new Date().toISOString(),
    };
    // Validate if end mark added
    const endMarkAdded =
      solutionLabel.includes(4) || solutionLabel.includes("4");

    if (!endMarkAdded) {
      setShowWarning(true);
      return;
    }
    setShowWarning(false);
    updateAssessmentResult(data).then(() => {
      hist.push(`/admin/result`);
    });
  };

  const [solutionLabel, setSolutionLabel] = useState(
    assessmentResults.SoundsIndex !== null
      ? assessmentResults.SoundsIndex.split(",")
      : zeros(assessment.Body.split(",")),
  );

  const [solutionDetailsLabel, setSolutionDetailsLabel] = useState(
    assessmentResults.SoundsLength !== null
      ? assessmentResults.SoundsLength.split(",")
      : zeros(assessment.Body.split(",")),
  );

  const [scores, setScores] = useState(() => {
    if (
      assessmentResults.Scores !== null &&
      assessmentResults.Scores !== undefined
    ) {
      return assessmentResults.Scores.split(",").map((score) => {
        const parsed = parseInt(score, 10);
        return isNaN(parsed) ? 0 : parsed;
      });
    }
    // Initialize with zeros based on assessment length
    return new Array(format(assessment).length).fill(0);
  });

  const [comment, SetComment] = useState(
    assessmentResults.Comment === null ? "" : assessmentResults.Comment,
  );

  const [doneCurrent, setDoneCurrent] = useState(
    location.pathname.includes("/assessment/preview/"),
  );

  const [showWarning, setShowWarning] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  // Calculate scores based on solutionLabel and solutionDetailsLabel
  useEffect(() => {
    if (solutionLabel?.length && solutionDetailsLabel?.length) {
      // Find the end mark position
      const endMarkIndex = solutionLabel.findIndex(
        (val) => val === "4" || val === 4,
      );

      // Create a new scores array to update all at once
      const newScores = [...scores];

      // Go through solutionLabel and check
      for (let i = 0; i < solutionLabel.length; i++) {
        // Set score to 0 for items after end mark
        if (endMarkIndex !== -1 && i > endMarkIndex) {
          newScores[i] = 0;
        } else {
          // Recalculate scores for items before/at end mark
          if (
            (solutionLabel[i] === "0" || solutionLabel[i] === 0) &&
            (solutionDetailsLabel[i] === "0" || solutionDetailsLabel[i] === 0)
          ) {
            newScores[i] = 2; // Default score when no selection
          } else if (solutionLabel[i] === "1" || solutionLabel[i] === 1) {
            newScores[i] = 2; // Self-correct = 2 points
          } else if (solutionLabel[i] === "2" || solutionLabel[i] === 2) {
            newScores[i] = 0; // Incorrect = 0 points
          } else if (solutionLabel[i] === "3" || solutionLabel[i] === 3) {
            newScores[i] = 0; // Skip = 0 points
          } else if (solutionLabel[i] === "4" || solutionLabel[i] === 4) {
            newScores[i] = 0; // End mark = 0 points
          } else if (parseInt(solutionDetailsLabel[i]) > 0) {
            newScores[i] = 1; // 1-point column selected = 1 point
          }
        }
      }

      // Update scores all at once
      setScores(newScores);
    }
  }, [solutionLabel, solutionDetailsLabel]);

  // Validation End Mark
  useEffect(() => {
    if (solutionLabel?.length) {
      console.log("solutionLabel", solutionLabel);
      validateEndMark(solutionLabel);
    }
  }, [solutionLabel]);

  return (
    <form className="w-80 mx-auto" onSubmit={(e) => onSubmit(e)}>
      <table className=" table bg-light">
        <thead>
          <tr>
            <th>Test Items</th>
            <th>Correct / 2 points</th>
            <th>Correct / 1 points</th>
            {/* <th>Incorrect</th> */}
            {isAuthenticated && <th>Score</th>}
          </tr>
        </thead>
        <tbody>
          {format(assessment).map((word, id) => {
            return (
              <tr key={id}>
                <td className="align-middle py-4">{word.word}</td>
                {/* Correct /2 Points Col */}
                <td className="align-middle py-4">
                  <div className="position-relative">
                    {/* Click Trigger */}
                    <ContextMenuTrigger id={"same_unique_identifier" + id}>
                      <span
                        onClick={() => {
                          if (isAuthenticated && !doneCurrent) {
                            let temp = [...solutionLabel];
                            let tempDetail = [...solutionDetailsLabel];
                            if (parseInt(temp[id]) === 0) {
                              temp[id] = 2 + "";
                            } else if (parseInt(temp[id]) === 2) {
                              temp[id] = 1 + "";
                            } else if (parseInt(temp[id]) === 1) {
                              temp[id] = 3 + "";
                            } else {
                              temp[id] = 0 + "";
                            }
                            tempDetail[id] = 0 + "";
                            setSolutionLabel(temp);
                            setSolutionDetailsLabel(tempDetail);
                          }
                        }}
                      >
                        {/* id=1 Self-correct */}
                        {parseInt(solutionLabel[id]) === 1 && (
                          <div
                            style={{
                              position: "absolute",
                              display: "inline-block",
                              bottom: "100%",
                              left: "0",
                            }}
                            className=" w-100"
                          >
                            <span className="self-correct px-1  d-inline-flex align-items-center justify-content-center">
                              <span>SC</span>
                            </span>
                          </div>
                        )}
                        {/* id=2 Incorrect */}
                        {parseInt(solutionLabel[id]) === 2 && (
                          <div
                            style={{
                              position: "absolute",
                              display: "inline-block",
                              bottom: "100%",
                              left: "0",
                            }}
                            className=" w-100"
                          >
                            <span className="incorrect px-1  d-inline-flex align-items-center justify-content-center">
                              <span>/</span>
                            </span>
                          </div>
                        )}
                        {/* id=3 Skip */}
                        {parseInt(solutionLabel[id]) === 3 && (
                          <div
                            style={{
                              position: "absolute",
                              display: "inline-block",
                              bottom: "100%",
                              left: "0",
                            }}
                            className=" w-100"
                          >
                            <span className="skip px-1  d-inline-flex align-items-center justify-content-center">
                              <span>-</span>
                            </span>
                          </div>
                        )}

                        {/* id=4 End mark */}
                        {parseInt(solutionLabel[id]) === 4 && (
                          <span
                            style={{ color: "#FAA525" }}
                            className="time-out px-1  d-inline-flex align-items-center justify-content-center"
                          >
                            <span>]</span>
                          </span>
                        )}

                        <span className="button-non">{word.solution}</span>
                      </span>
                    </ContextMenuTrigger>

                    {/* Menu Context */}
                    {isAuthenticated && !doneCurrent && (
                      <ContextMenu
                        id={"same_unique_identifier" + id}
                        className="card react-contextmenu p-1"
                      >
                        {/* id=4 End mark */}
                        <MenuItem
                          onClick={() => {
                            let temp = [...solutionLabel];
                            let tempDetail = [...solutionDetailsLabel];
                            // Clear any existing end marks (value 4)
                            for (let i = 0; i < temp.length; i++) {
                              if (temp[i] === "4" || temp[i] === 4) {
                                temp[i] = "0";
                              }
                            }
                            temp[id] = 4;
                            tempDetail[id] = 0;
                            setSolutionLabel(temp);
                            setSolutionDetailsLabel(tempDetail);
                          }}
                          className="p-2 btn react-contextmenu-item d-flex align-items-center justify-content-start"
                        >
                          <span
                            style={{ color: "#FAA525" }}
                            className="time-out px-1 d-inline-flex align-items-center justify-content-center"
                          >
                            <b>]</b>
                          </span>
                          <span>
                            <b>End Mark</b>
                          </span>
                        </MenuItem>

                        {/* id=2 Incorrect */}
                        <MenuItem
                          onClick={() => {
                            let temp = [...solutionLabel];
                            let tempDetail = [...solutionDetailsLabel];
                            temp[id] = 2;
                            tempDetail[id] = 0;
                            setSolutionLabel(temp);
                            setSolutionDetailsLabel(tempDetail);
                          }}
                          className="p-2 btn react-contextmenu-item d-flex align-items-center justify-content-start"
                        >
                          <span className="incorrect px-1 txt-primary d-inline-flex align-items-center justify-content-center">
                            /
                          </span>
                          <span>
                            <b>Incorrect Response (error)</b>
                          </span>
                        </MenuItem>

                        {/* id=1 Self-correct */}
                        <MenuItem
                          onClick={() => {
                            let temp = [...solutionLabel];
                            let tempDetail = [...solutionDetailsLabel];
                            temp[id] = 1;
                            tempDetail[id] = 0;
                            setSolutionLabel(temp);
                            setSolutionDetailsLabel(tempDetail);
                          }}
                          className="p-2 btn react-contextmenu-item d-flex align-items-center justify-content-start"
                        >
                          <span className="self-correct px-1 d-inline-flex align-items-center justify-content-center">
                            SC
                          </span>
                          <span>
                            <b>Self Correct (no error)</b>
                          </span>
                        </MenuItem>

                        {/* id=3 Skip */}
                        <MenuItem
                          onClick={() => {
                            let temp = [...solutionLabel];
                            let tempDetail = [...solutionDetailsLabel];
                            temp[id] = 3;
                            tempDetail[id] = 0;
                            setSolutionLabel(temp);
                            setSolutionDetailsLabel(tempDetail);
                          }}
                          className="p-2 btn react-contextmenu-item d-flex align-items-center justify-content-start"
                        >
                          <span className="skip px-1 d-inline-flex align-items-center justify-content-center">
                            -
                          </span>
                          <span>
                            <b>Skipped (error)</b>
                          </span>
                        </MenuItem>

                        {/* Cancel */}
                        <MenuItem
                          onClick={() => {
                            let temp = [...solutionLabel];
                            let tempDetail = [...solutionDetailsLabel];
                            temp[id] = 0;
                            tempDetail[id] = 0;
                            setSolutionLabel(temp);
                            setSolutionDetailsLabel(tempDetail);
                          }}
                          className="p-2 btn react-contextmenu-item d-flex align-items-center justify-content-start"
                        >
                          <span className="time-out px-1 d-inline-flex align-items-center justify-content-center"></span>
                          <span>
                            <b>Cancel</b>
                          </span>
                        </MenuItem>
                      </ContextMenu>
                    )}
                  </div>
                </td>
                {/* Correct /1 Points Col */}
                <td className="align-middle py-4">
                  {word.solutionDetails.map((w, i) => {
                    return (
                      <span
                        key={parseInt(id + "" + i)}
                        onClick={() => {
                          if (isAuthenticated && !doneCurrent) {
                            let temp = [...solutionLabel];
                            let tempDetail = [...solutionDetailsLabel];

                            if (parseInt(tempDetail[id]) === i + 1) {
                              tempDetail[id] = 0 + "";
                            } else {
                              tempDetail[id] = i + 1 + "";
                            }
                            temp[id] = 0 + "";

                            setSolutionLabel(temp);
                            setSolutionDetailsLabel(tempDetail);
                          }
                        }}
                      >
                        <span
                          className={`${
                            parseInt(solutionDetailsLabel[id]) === i + 1
                              ? "self-correct"
                              : "time-out"
                          } px-1   d-inline-flex align-items-center justify-content-center`}
                        >
                          {w}
                        </span>
                      </span>
                    );
                  })}
                </td>

                {/* Incorrect Col - Hide */}
                {/* <td className="align-middle py-4">
                  <span
                    onClick={() => {
                      if (isAuthenticated && !doneCurrent) {
                        let temp = [...solutionLabel];
                        let tempDetail = [...solutionDetailsLabel];
                        temp[id] = 0 + "";
                        tempDetail[id] = 0 + "";
                        setSolutionLabel(temp);
                        setSolutionDetailsLabel(tempDetail);
                        let arr = [...scores];
                        arr[id] = 0;
                        setScores(arr);
                      }
                    }}
                  >
                    <span
                      className={`${
                        parseInt(solutionLabel[id]) === 0 &&
                        parseInt(solutionDetailsLabel[id]) === 0 &&
                        scores[id] !== undefined
                          ? "incorrect"
                          : "time-out"
                      } px-1   d-inline-flex align-items-center justify-content-center`}
                    >
                      0
                    </span>
                  </span>
                </td> */}

                {/* Score Col */}
                {isAuthenticated && (
                  <td className="align-middle py-4">
                    <input
                      type="number"
                      max={2}
                      min={0}
                      disabled
                      readOnly={true}
                      onChange={(e) => {
                        let arr = [...scores];
                        arr[id] = parseInt(e.target.value);
                        setScores(arr);
                      }}
                      value={scores[id] === undefined ? 0 : scores[id]}
                      className="form-control form-silly mr-2 d-inline px-0 text-center "
                    />
                    &nbsp;&nbsp;/&nbsp;2
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
      {isAuthenticated && (
        <Fragment>
          <div class="form-floating my-2">
            <textarea
              onChange={(e) => SetComment(e.target.value)}
              class="form-control"
              placeholder="Leave a comment here"
              id="floatingTextarea2"
              readOnly={location.pathname.includes("/assessment/preview/")}
              value={comment}
              style={{ height: "100px" }}
            ></textarea>
            <label for="floatingTextarea2">Comments</label>
          </div>
          <div
            className={`d-flex align-items-center justify-content-${
              !doneCurrent ? "end" : "between"
            } my-3`}
          >
            {doneCurrent && (
              <>
                <div className="">
                  <div className="">
                    #&nbsp;&nbsp;Correct{" "}
                    {scores.reduce((accumulator, currentScore, index) => {
                      // Find the end mark position
                      const endMarkIndex = solutionLabel.findIndex(
                        (val) => val === "4" || val === 4,
                      );

                      // If there's an end mark and current index is after it, don't add to total
                      if (endMarkIndex !== -1 && index > endMarkIndex) {
                        return accumulator;
                      }

                      // Handle empty string cases
                      if (accumulator === "") {
                        return currentScore === "" ? 0 : currentScore;
                      }
                      if (currentScore === "") {
                        return accumulator;
                      }

                      // Normal accumulation
                      return accumulator + currentScore;
                    }, 0)}
                    {/*{' '}
                    &nbsp;/&nbsp; {assessment.Body.split(',').length * 2}*/}
                  </div>
                </div>
              </>
            )}
            {!location.pathname.includes("/assessment/preview/") && (
              <div className="d-flex align-items-center justify-content-end mb-2  p-2">
                {doneCurrent && (
                  <button
                    type="reset"
                    className="button-primary btn-block btn px-5 mx-2"
                    onClick={() => {
                      // setScores([]);
                      setDone(false);
                      setDoneCurrent(false);
                      // setSolutionDetailsLabel(zeros(assessment.Body.split(",")));
                      // setSolutionLabel(zeros(assessment.Body.split(",")));
                      // forceUpdate();
                    }}
                  >
                    Edit
                  </button>
                )}

                {!doneCurrent && (
                  <button
                    type="reset"
                    className="button-primary btn-block btn px-5 mx-2"
                    onClick={() => {
                      setScores([]);
                      setDone(false);
                      setDoneCurrent(false);
                      setSolutionDetailsLabel(
                        zeros(assessment.Body.split(",")),
                      );
                      setSolutionLabel(zeros(assessment.Body.split(",")));
                      forceUpdate();
                    }}
                  >
                    Clear
                  </button>
                )}

                {!doneCurrent ? (
                  <div
                    className="button-primary btn-block btn px-5"
                    onClick={() => {
                      setRestartKey(restartKey + 1);
                      setPlay(false);
                      setDone(true);
                      setDoneCurrent(true);
                      forceUpdate();
                    }}
                  >
                    Done
                  </div>
                ) : (
                  <button
                    className="button-primary btn-block btn px-5"
                    type="submit"
                  >
                    Submit
                  </button>
                )}

                {/* Delete Modal */}
                <Modal
                  show={showDeleteModal}
                  onHide={() => setShowDeleteModal(false)}
                  centered
                >
                  <Modal.Header closeButton>
                    <Modal.Title>Delete Assigned Assessment</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    Are you sure you want to delete assigned assessment?
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      onClick={() => setShowDeleteModal(false)}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="danger"
                      onClick={() => {
                        deleteResult(assessmentResults.ResultID, user.SchoolID);
                        hist.push("/admin/result");
                        clearResult();
                        setShowDeleteModal(false);
                      }}
                    >
                      Confirm
                    </Button>
                  </Modal.Footer>
                </Modal>

                {/* Delete Button */}
                <Button
                  variant="danger"
                  className="d-flex align-items-center px-4 mx-2"
                  onClick={() => setShowDeleteModal(true)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-trash-fill me-2"
                    viewBox="0 0 16 16"
                  >
                    <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z" />
                  </svg>
                  Delete
                </Button>

                {/* Warning Modal */}
                {/* ✅ Replace the Bootstrap modal with React Bootstrap Modal */}
                <Modal
                  show={showWarning}
                  onHide={() => setShowWarning(false)}
                  centered
                >
                  <Modal.Header closeButton>
                    <Modal.Title>Submission Failed!</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    Missing end mark! Please add an end mark (]) before
                    submitting.
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      onClick={() => setShowWarning(false)}
                    >
                      OK, I'll add the end mark
                    </Button>
                  </Modal.Footer>
                </Modal>
              </div>
            )}
          </div>
        </Fragment>
      )}
    </form>
  );
};

export default AssessmentFirstSound;
